import { EntityMetadataMap } from '@ngrx/data';
import { Client, User, Event } from '../models';

const entityMetadata: EntityMetadataMap = {
  Client: {
    selectId: (client: Client) => client.uuid,
  },
  Event: {
    selectId: (event: Event) => event.id,
  },
  User: {
    selectId: (user: User) => user.email,
  },
};

const pluralNames = {
  Client: 'Clients',
};

export const entityConfig = {
  entityMetadata,
  pluralNames,
};
